import teamPhoto from './our_team/team-photo.jpg';
import alena from './our_team/alena.jpg';
import artur from './our_team/artur.jpg';
import eva from './our_team/eva.jpg';
import iva from './our_team/iva.jpg';
import jan from './our_team/jan.jpg';
import jiri from './our_team/jirka.jpg';
import kamila from './our_team/kamila.jpg';
import karel from './our_team/karel.jpg';
import lenka from './our_team/lenka.jpg';
import nikola from './our_team/nikola.jpg';
import pavel from './our_team/pavel.jpg';
import petr from './our_team/petr.jpg';
import radim from './our_team/radim.jpg';
import ika_default_portrait_female from './our_team/ika_portrait_female.png';
import ika_default_portrait_male from './our_team/ika_portrait_male.png';

import bara from './our_team/ika_portrait_female.png';
import jand from './our_team/ika_portrait_male.png';

const teamPhotos = {
  teamPhoto,
  radim,
  jan,
  jiri,

  alena,
  artur,
  bara,
  eva,
  iva,
  jand,
  kamila,
  karel,
  lenka,
  nikola,
  pavel,
  petr,

  ika_default_portrait_female,
  ika_default_portrait_male,
};

export default teamPhotos;
